import PropTypes from "prop-types";

// Pagination settings
export const ITEMS_PER_PAGE = 100;
export const INITIAL_PAGE = 1;
export const paginationProps = PropTypes.shape({
  numberOfItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  initialPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingConfig: PropTypes.shape({
    loading: PropTypes.bool,
    message: PropTypes.string,
  }),
});

export const DEFAULT_ERROR_MESSAGE =
  "There was an error completing the request";

export const USER_ROLES = {
  user: "user",
  dictionary: "dictionary",
  userAdmin: "user_admin",
  systemAdmin: "system_admin",
  readabilitySettings: "readability_settings",
  acronymSettings: "acronym_settings",
  discoverySettings: "discovery_settings",
  excelOutputs: "excel_outputs",
};
